import React from "react"
import logo from "./logo.svg"
import "./App.css"
import Kasten from "./components/wavyContainer"
import "./fonts.css"
import ModelViewer from "./components/modelViewer"
import Desktop from "./components/desktop"

function App() {
    return <Desktop></Desktop>
}

export default App
